export const getCountries = filters => {
  const country = filters.find(filter => filter.route === 'countries');

  if (!country || !country.children) return [];
  return country.children;
};

// Get country from session storage if it exists else return the first value
export const getCountryFromSessionStorage = countries => {
  const countryOnSession = JSON.parse(sessionStorage.getItem('country'));

  if (countryOnSession) {
    const country = countries.find(
      countryItem => countryOnSession.value === countryItem.id
    );
    return country;
  }
  return countries[0];
};

// Get cost center from session storage if it exists else return the first value
export const getCostCenterFromLocalStorage = costCenters => {
  const costcenterOnSession = JSON.parse(sessionStorage.getItem('costcenter'));
  if (costcenterOnSession) {
    const costcenter = costCenters.find(
      costCenterItem => costcenterOnSession.value === costCenterItem.id
    );
    return costcenter;
  }
  return costCenters[0];
};

const setLegacyActiveSession = source => {
  localStorage.setItem('legacy/activeSession', JSON.stringify(source));
};

export const setDefaultSource = (
  country,
  costcenter,
  countries,
  checkLocal
) => {
  let source = { country, costcenter };

  if (!countries || countries.length === 0) {
    source = {
      country: {},
      costcenter: {}
    };
    setLegacyActiveSession(source);

    return source;
  }

  const defaultCountry = checkLocal
    ? getCountryFromSessionStorage(countries)
    : countries[0];

  if (!country) {
    let defaultCostcenter = null;
    if (defaultCountry.children && defaultCountry.children.length > 0) {
      // defaultCostcenter = defaultCountry.children[0];
      defaultCostcenter = checkLocal
        ? getCostCenterFromLocalStorage(defaultCountry.children)
        : defaultCountry.children[0];
    }

    if (!defaultCostcenter) {
      source = {
        country: {
          label: defaultCountry.title,
          value: defaultCountry.id
        },
        costcenter: {}
      };

      setLegacyActiveSession(source);
      return source;
    }
    if (costcenter) {
      source = {
        country: {
          label: defaultCountry.title,
          value: defaultCountry.id
        },
        costcenter
      };

      setLegacyActiveSession(source);
      return source;
    }

    source = {
      country: {
        label: defaultCountry.title,
        value: defaultCountry.id
      },
      costcenter: {
        label: defaultCostcenter.title,
        value: defaultCostcenter.id
      }
    };

    setLegacyActiveSession(source);
    return source;
  }

  localStorage.setItem('legacy/activeSession', JSON.stringify(source));
  return source;
};



// WEBPACK FOOTER //
// ./src/utils/helpers/costcenter.js